import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * The read view's "nothing here yet" note (#21239): one line, shared by every place a read
 * section can turn up with nothing to show — a `group` section (`group.component.ts`), a flat
 * `title` section (`title.component.ts`), and the Overzicht tab (`overview-tab.component.ts`)
 * when every flagged answer is hidden. Previously three copies of the same markup; extracted so
 * the wording and styling can only drift in one place.
 *
 * No inputs: the note is always the same sentence. `:host { display: block }` so it lays out like
 * the `<p>` it replaces, not like the inline element a component host defaults to.
 */
@Component({
  selector: 'dd-read-section-empty',
  template: `<p
    class="m-0 border-b border-[color:var(--dd-card-border)] py-3 text-[0.8125rem] leading-[1.4] text-secondary"
    data-cy="read-section-empty">
    Nog niets ingevuld
  </p>`,
  styles: `
    :host {
      display: block;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReadSectionEmptyComponent {}
